import React from 'react'

function Arrow4Icon({ height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M12 18L18 12L12 6" stroke="#393D63" />
      <path d="M6 18L12 12L6 6" stroke="#393D63" />
    </svg>
  )
}

export default Arrow4Icon
